import Menu from "assets/images/icon/svg/Menu";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DotMenu from "assets/images/icon/svg/DotMenu";
import {
  resetEmployeeSetting,
  setAccountDetailsSheet,
  setAddBankBottomSheet,
  setBottomSheet,
  setBusinessBottomSheet,
  setDashboardSheet,
  setEditEmployeeData,
  setEditEmployees,
  setEmployeeData,
  setLearningBottomSheet,
  setLoanBottomSheet,
  setMyEmployees,
  setMyProduct,
  setProfitLossBottomSheet,
} from "redux/container/userSlice";
import Modal from "react-modal";
import CancelPopUp from "assets/images/icon/svg/CancelPopUp";
import {
  creditFee,
  paymentMethod,
  paymentTerm,
  setPaymentMethodText,
  setPaymentName,
  deliveryDate,
} from "redux/container/paymentMethodSlice";
import MenuLeftArrow from "assets/images/icon/svg/MenuLeftArrow";
import { clearExpense, clearRevenue } from "redux/container/accountSlice";
import Filter from "assets/images/icon/svg/Filter";
import {
  dateTimeFormatter,
  digitChanger,
  numberWithCommas,
} from "helpers/helper";
import { getSelectedDate } from "redux/container/dashboardSlice";
import moment from "moment";
import { Html5QrcodeScanner } from "html5-qrcode";
import { IonSegment, IonSegmentButton, IonSpinner } from "@ionic/react";
import Cross from "assets/images/icon/svg/Cross";
import TextInputWithIcon from "./TextInputWithIcon";
import Product from "services/Product";
import Filter2 from "assets/images/icon/svg/Filter2";
export default function BackButtonTitle({
  title,
  burgerMenu,
  menuIconClick,
  from,
  filter,
  setGetDate,
  search,
  setSearch,
  getProductList,
  setFilterClicked,
  filterClicked,
}) {
  const [isOpen, setIsOpen] = useState(false);
  // * Start of Product Bar Code States
  const [barcodeModal, setBarcodeModal] = useState(false);
  const [scannedCode, setScannedCode] = useState(null);
  const [scanner, setScanner] = useState(null);
  const [product, setProduct] = useState([]);
  const [loader, setLoader] = useState(true);
  const [initInventory, setInitInventory] = useState(0);
  // ! End of Product Bar Code States
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const ekkLanguage = useSelector((state) => state.lan.lan);
  const date = useSelector((state) => state.dashboard.dateInfo);
  let value = date?.level ? date?.level : "this month";
  const dateFormat = useSelector((state) => state.date.format);
  const searchParams = new URLSearchParams(location?.search);

  const onCloseModal = () => {
    setIsOpen(false);
  };
  let { id } = useParams();
  // Functions of Product Bar Code Scan
  const openBarcodeModal = () => {
    setBarcodeModal(true);
    setTimeout(() => {
      initializeScanner();
    }, 100);
  };

  const closeBarcodeModal = () => {
    if (scanner) {
      scanner.clear();
      setScanner(null);
    }
    setBarcodeModal(false);
    setScannedCode(null);
    setProduct([]);
  };

  const initializeScanner = () => {
    if (scanner) {
      scanner.clear();
      setScanner(null);
    }

    const scannerConfig = {
      fps: 10,
      qrbox: { width: 250, height: 250 },
      aspectRatio: 1.0,
      experimentalFeatures: {
        useBarCodeDetectorIfSupported: true,
      },
      showTorchButtonIfSupported: true,
      showZoomSliderIfSupported: true,
    };

    const html5QrCodeScanner = new Html5QrcodeScanner(
      "scanner-container",
      scannerConfig,
      false // Don't show header
    );

    html5QrCodeScanner.render(
      (decodedText) => {
        setScannedCode(decodedText);
        setSearch(decodedText);
        html5QrCodeScanner.clear();
      },
      (errorMessage) => {
        console.error("QR Code scan error:", errorMessage);
      }
    );

    setScanner(html5QrCodeScanner);
  };
  const inventoryUpdateHandler = async () => {
    setLoader(true);
    let productInfo = {
      product: {
        product_id: product.product_id,
      },
      catalog: {
        inventory_id: product.inventory_id,
        inventory_quantity: initInventory,
        cat_id: product?.cat_id,
      },
    };
    let offerInfo = {
      offers: {
        id: product?.id,
        inventory_quantity: initInventory,
        inventory_id: product.inventory_id,
      },
    };
    let response =
      product.type === "offer"
        ? await Product.updateOffer(offerInfo)
        : await Product.updateProduct(productInfo);
    if (response.status === 200) {
      setLoader(false);
      closeBarcodeModal();
      getProductList();
      let updateProduct = { ...product, inventory_quantity: initInventory };
      setProduct(updateProduct);
    } else {
      setLoader(false);
    }
  };
  const handleScanAgain = () => {
    if (scanner) {
      scanner.clear();
      setScanner(null);
    }
    setScannedCode(null);
    setProduct([]);
    setLoader(true);

    // Small delay to ensure DOM is ready
    setTimeout(() => {
      const scannerContainer = document.getElementById("scanner-container");
      if (scannerContainer) {
        scannerContainer.innerHTML = "";
        initializeScanner();
      }
    }, 500);
  };
  useEffect(() => {
    return () => {
      if (scanner) {
        scanner.clear();
      }
    };
  }, [scanner]);

  const getProduct = async (scannedCode) => {
    let response = await Product.singleSellerProductSearch(scannedCode, "all");
    if (response.status === 200) {
      setLoader(false);
      setProduct(response.results[0]);
      setInitInventory(response.results[0]?.inventory_quantity ?? 0);
    } else {
      setLoader(false);
      setProduct([]);
    }
  };
  useEffect(() => {
    if (scannedCode) {
      getProduct(scannedCode);
    }
  }, [scannedCode]);
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: "0px",
      width: "300px",
      transition: ".4s all ease",
      borderRadius: 12,
    },
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      transition: ".4s all ease",
      backgroundColor: "rgba(0,0,0,.5)",
    },
  };
  const customModalStyles2 = {
    content: {
      ...customStyles.content,
      height: "auto",
      maxHeight: "calc(100% - 60px)",
    },
    overlay: {
      ...customStyles.overlay,
    },
  };
  const options = [
    { value: "today", label: ekkLanguage.dashboard.today, name: "Today" },
    {
      value: "yesterday",
      label: ekkLanguage.dashboard.yesterday,
      name: "Yesterday",
    },
    {
      value: "week",
      label: ekkLanguage.dashboard.thisWeek,
      name: "This Week",
    },
    {
      value: "month",
      label: ekkLanguage.dashboard.thisMonth,
      name: "This Month",
    },
    {
      value: "year",
      label: ekkLanguage.dashboard.thisYear,
      name: "This Year",
    },
    {
      value: "lastWeek",
      label: ekkLanguage.dashboard.lastWeek,
      name: "Last Week",
    },
    {
      value: "lastMonth",
      label: ekkLanguage.dashboard.lastMonth,
      name: "Last Month",
    },
    {
      value: "lastYear",
      label: ekkLanguage.dashboard.lastYear,
      name: "Last Year",
    },
    // { value: "custom", label: ekkLanguage.dashboard.custom },
    // { value: "selectDay", label: ekkLanguage.dashboard.selectDay },
  ];
  const handleFilter = (value) => {
    let timeDate = dateTimeFormatter(value?.value);
    let dateTime = { ...timeDate, level: value?.name };
    setGetDate({
      start: moment(timeDate?.start).format("YYYY-MM-DD"),
      end: moment(timeDate?.end).format("YYYY-MM-DD"),
    });
    let dateTimeData = {
      start: moment(timeDate?.start).format("YYYY-MM-DD"),
      end: moment(timeDate?.end).format("YYYY-MM-DD"),
      level: value?.name,
    };
    dispatch(getSelectedDate(dateTimeData));
    // dispatch(getSelectedDate(dateTime));
    setFilterOpen(false);
    setFilterClicked(true);
  };

  const [filterOpen, setFilterOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setFilterOpen(false);
      }
    };

    window.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <>
      <div className="top-nav-bar z-40 flex pl-4 items-center justify-between py-2 fixed left-0 top-0 w-full">
        <div className="flex items-center">
          {burgerMenu ? (
            <div
              className="flex items-center justify-center h-10 w-10 mr-4 rounded-[10px]"
              onClick={menuIconClick}
            >
              <Menu color="white" />
            </div>
          ) : (
            <div
              className="flex items-center justify-center h-10 w-10 mr-4 rounded-[10px] cursor-pointer"
              onClick={() => {
                if (location.pathname === "/create-order") {
                  let localCart = localStorage.getItem("cart");
                  let cartParse = JSON.parse(localCart);
                  if (cartParse?.length > 0) {
                    setIsOpen(true);
                  } else {
                    navigate(-1);
                  }
                } else if (location.pathname === "/add-bank-account") {
                  navigate("/added-bank-list");
                } else if (location.pathname === "/added-bank-list") {
                  navigate("/profile");
                } else if (location.pathname === "/profile") {
                  navigate("/home");
                } else if (location.pathname === "/revenue-form") {
                  dispatch(clearRevenue());
                  navigate("/accounts");
                } else if (location.pathname.split("/")[1] === "revenue-edit") {
                  dispatch(clearRevenue());
                  navigate(`/transaction-details/${id}`);
                } else if (location.pathname.split("/")[1] === "expense-edit") {
                  dispatch(clearExpense());
                  navigate(`/transaction-details/${id}`);
                } else if (
                  location.pathname.split("/")[1] === "transaction-details"
                ) {
                  if (searchParams.get("from") === "dashboard") {
                    navigate(-1);
                  }
                  else if (searchParams.get("from") === "profitLoss") {
                    navigate(`/accounts?from=${searchParams.get("from")}`);
                  } else {
                    navigate("/accounts");
                  }
                } else if (location.pathname === "/expense-form") {
                  dispatch(clearExpense());
                  navigate("/accounts");
                } else if (location.pathname === "/create-employee") {
                  dispatch(resetEmployeeSetting());
                  dispatch(setEmployeeData({}));
                  navigate("/employees-list");
                } else if (location.pathname === "/total-profit-loss" || location.pathname === "/total-profit-loss/") {
                  navigate("/accounts-dashboard");
                }else if (location.pathname === "/accounts-dashboard" || location.pathname === "/accounts-dashboard/") {
                  navigate("/home");
                } else if (location.pathname === "/employees-list") {
                  navigate("/home");
                } else if (
                  location.pathname.split("/")[1] === "update-employee"
                ) {
                  dispatch(setEditEmployeeData({}));
                  navigate(`/employee-details/${id}`);
                } else if (
                  location.pathname.split("/")[1] === "employee-details"
                ) {
                  if (from == "dashboard") {
                    navigate(-1);
                  } else {
                    navigate(`/employees-list`);
                  }
                } else {
                  navigate(-1);
                }
              }}
            >
              <MenuLeftArrow />
            </div>
          )}

          <h5 className="text-white text-18 font-bold">{title}</h5>
        </div>
        <div className="flex items-center">
          {filter && (
            <div className="mr-4 relative" ref={dropdownRef}>
              <span onClick={() => setFilterOpen(!filterOpen)}>
                <Filter2 />
              </span>
              {filterOpen && (
                <div
                  className="absolute right-0 top-full mt-2 w-48 bg-white rounded-lg shadow-lg z-50"
                  onBlur={() => setFilterOpen(false)}
                >
                  <div className="py-2">
                    {options?.map((option) => (
                      <button
                        className={`w-full text-left px-4 py-2 ${
                          value === option?.name ? "bg-gray-200" : "bg-white"
                        } hover:bg-gray-200`}
                        onClick={() => handleFilter(option)}
                      >
                        {option?.name}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
          {from === "loan" && (
            <div className="mr-2 ml-6 cursor-pointer">
              <span onClick={() => dispatch(setLoanBottomSheet(true))}>
                <DotMenu />
              </span>
            </div>
          )}
          {from === "orderDetailsPage" && (
            <div className="mr-4">
              <span onClick={() => dispatch(setBottomSheet(true))}>
                <DotMenu />
              </span>
            </div>
          )}
          {from === "businessProfile" && (
            <div className="mr-4">
              <span onClick={() => dispatch(setBusinessBottomSheet(true))}>
                <DotMenu />
              </span>
            </div>
          )}
          {from === "addedBankList" && (
            <div className="mr-4">
              <span onClick={() => dispatch(setAddBankBottomSheet(true))}>
                <DotMenu />
              </span>
            </div>
          )}
          {from === "myEmployees" && (
            <div className="mr-4">
              <span onClick={() => dispatch(setMyEmployees(true))}>
                <DotMenu />
              </span>
            </div>
          )}
          {from === "employeesDetails" && (
            <div className="mr-4">
              <span onClick={() => dispatch(setEditEmployees(true))}>
                <DotMenu />
              </span>
            </div>
          )}
          {from === "accDetails" && (
            <div className="mr-4">
              <span onClick={() => dispatch(setAccountDetailsSheet(true))}>
                <DotMenu />
              </span>
            </div>
          )}
          {from === "profitLoss" && (
            <div className="mr-4">
              <span onClick={() => dispatch(setProfitLossBottomSheet(true))}>
                <DotMenu />
              </span>
            </div>
          )}
          {from === "learning" && (
            <div className="mr-4">
              <span onClick={() => dispatch(setLearningBottomSheet(true))}>
                <DotMenu />
              </span>
            </div>
          )}
          {from === "dashboard" && (
            <div className="mr-4">
              <span onClick={() => dispatch(setDashboardSheet(true))}>
                <DotMenu />
              </span>
            </div>
          )}
          {/* {from === "myProductList" && (
            <div className="mr-4">
              <span onClick={() => dispatch(setMyProduct(true))}>
                <DotMenu />
              </span>
            </div>
          )} */}
          {from === "myProductList" && (
            <div
              onClick={openBarcodeModal}
              className={` bg-white rounded-[10px] flex cursor-pointer items-center justify-center ${
                from === "myProductList" && "mr-3"
              }`}
              style={{
                boxShadow: "0px 3px 10px rgba(0, 0, 0, 0.1)",
                width: "40px",
                height: "40px",
              }}
            >
              <img
                src="/assets/images/barcode-scanner.png"
                alt="icon"
                className="w-5 h-5"
              />
            </div>
          )}
        </div>
      </div>
      <Modal
        closeTimeoutMS={200}
        isOpen={isOpen}
        onRequestClose={onCloseModal}
        id="pwa-modal"
        style={customStyles}
      >
        <div className="p-5">
          <span className="mb-2 inline-block mx-2">
            <CancelPopUp />
          </span>
          <h6 className="text-16 font-bold pb-[10px]">
            {ekkLanguage.createOrder.alert}
          </h6>
          <p className="text-12 font-medium pb-[10px] text-black-500">
            {ekkLanguage.createOrder.backButtonMessage}
          </p>
          <div className="flex justify-end pt-3">
            <button
              color="primary"
              className="font-bold h-10 rounded-[7px] w-1/2 ml-2 border-2 bg-primary text-white text-14"
              onClick={() => {
                dispatch(deliveryDate(""));
                dispatch(creditFee(0));
                dispatch(paymentTerm(0));
                dispatch(paymentMethod(""));
                dispatch(setPaymentMethodText(""));
                dispatch(setPaymentName(""));
                localStorage.removeItem("cart");
                navigate("/home");
              }}
            >
              {ekkLanguage.createOrder.okBtnLabel}
            </button>
          </div>
        </div>
      </Modal>
      {/*Product Bar Code Modal  */}
      <Modal
        style={customModalStyles2}
        closeTimeoutMS={200}
        isOpen={barcodeModal}
        onRequestClose={closeBarcodeModal}
        classNames="bottom-sheet-modal"
      >
        <div className="p-5">
          <div className="border-b-2 mb-4 flex justify-between">
            <h4 className="text-14 text-222222 font-bold pb-[10px]">
              {ekkLanguage.productList.scanYourBarcode}
            </h4>
            <span onClick={closeBarcodeModal} className="cursor-pointer">
              <Cross />
            </span>
          </div>
          <div>
            <div className="mb-5">
              <div className=" items-center justify-center">
                {!scannedCode ? (
                  <div className=" bg-gray-100">
                    <div
                      id="scanner-container"
                      className="w-full max-w-md"
                    ></div>
                    <p className="mt-4 text-gray-600">
                      {ekkLanguage.productList.ensureCameraPermissions}
                    </p>
                  </div>
                ) : (
                  <>
                    {loader ? (
                      <div className="flex justify-center items-center my-14">
                        <IonSpinner />
                      </div>
                    ) : (
                      <>
                        {" "}
                        {product?.id ? (
                          <div>
                            <div className=" bg-F5F5F5 py-2 px-3 rounded-[5px] relative overflow-hidden cursor-pointer ">
                              <h4 className="pr-10 font-medium text-12 text-black-1000 pb-[7px]">
                                {product?.title ?? product.name}
                              </h4>
                              <div>
                                <ul className="flex justify-between items-center">
                                  <li className="flex">
                                    {product.type === "variant" && (
                                      <img
                                        src="assets/images/package-box.png"
                                        alt="icon"
                                      />
                                    )}
                                    {product.type === "pack" && (
                                      <img
                                        src="assets/images/product-small.png"
                                        alt="icon"
                                      />
                                    )}
                                    {product.type === "offer" && (
                                      <img
                                        src="assets/images/discount-icon.png"
                                        alt="icon"
                                      />
                                    )}

                                    <span className="font-bold text-12 text-primary pl-1">
                                      {product?.country?.currency_symbol_native}
                                      {digitChanger(
                                        numberWithCommas(
                                          product?.consumer_price
                                        )
                                      )}{" "}
                                    </span>
                                  </li>
                                  <li className="flex">
                                    <img
                                      src="assets/images/warehouse.png"
                                      alt="icon"
                                    />
                                    <span className="font-bold text-12 text-primary pl-1">
                                      {digitChanger(
                                        product?.inventory_quantity
                                      )}
                                    </span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div>
                              <div className="mb-3">
                                <IonSegment
                                  scrollable
                                  className="orderBtnWrapper"
                                  value="set"
                                >
                                  <IonSegmentButton
                                    value="set"
                                    className="recent text-black-1000 no-ripple"
                                  >
                                    <button className="text-black-1000 font-sans p-0 font-normal shadow-none text-14">
                                      {ekkLanguage.productList.set}
                                    </button>
                                  </IonSegmentButton>
                                  <IonSegmentButton
                                    value="add"
                                    className="paid no-ripple"
                                  >
                                    <button className="text-success font-sans p-0 font-normal shadow-none text-14">
                                      {ekkLanguage.productList.add}
                                    </button>
                                  </IonSegmentButton>
                                </IonSegment>
                              </div>
                              <div>
                                <div>
                                  <TextInputWithIcon
                                    type="number"
                                    inputText={initInventory}
                                    setInputText={setInitInventory}
                                    placeholder={
                                      ekkLanguage.createProduct
                                        .initialInventoryPlaceHolder
                                    }
                                  />
                                </div>

                                <div className="flex">
                                  <button
                                    onClick={inventoryUpdateHandler}
                                    color="primary"
                                    className={`font-bold h-10 rounded-[5px] w-full  bg-success text-white flex justify-center items-center`}
                                  >
                                    {ekkLanguage.createProduct.updateBtn}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="flex justify-center items-center my-4">
                            <div>
                              <p>{ekkLanguage.productList.notFound}</p>
                              <button
                                className="mt-4 text-center bg-success text-white px-4 py-2 rounded"
                                onClick={handleScanAgain}
                              >
                                {ekkLanguage.productList.againScan}
                              </button>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}
